export default __webpack_public_path__ + "static/media/bg-pattern-bottom.a34eb319.svg";